import { render, staticRenderFns } from "./OfficerDetailsActiveLoans.vue?vue&type=template&id=58dd8538"
import script from "./OfficerDetailsActiveLoans.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsActiveLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports